import '@/App.css';
import { Suspense, lazy } from 'react';
import Loader from './components/Loader';

const Home = lazy(() => import('./pages/Home'));

function App() {
  return (
    <div className="App">
      <Suspense fallback={<Loader />}>
        <Home />
      </Suspense>
    </div>
  );
}

export default App;